import React from 'react';

import HeroHome from '../components/ui-elements/HeroHome';

function Home() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden relative">
      <main className="flex-grow relative z-10">
        <HeroHome />
      </main>
    </div>
  );
}

export default Home;